import{callMethod}from"./call.js";









export const callMixedMethod=(
{methodFunc,plugin,plugins,ErrorClass},
error,
...args)=>
{
const errorA=ErrorClass.normalize(error);
return callMethod({methodFunc,plugin,plugins,error:errorA,args})
};